"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _isEqual = _interopRequireDefault(require("lodash/isEqual"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _v = _interopRequireDefault(require("uuid/v4"));
var _xCircle = _interopRequireDefault(require("@spothero/icons/x-circle"));
var _TextInput = _interopRequireDefault(require("../TextInput/TextInput"));
var _TextInputPropTypes = _interopRequireDefault(require("../TextInput/TextInputPropTypes"));
var _AutoSuggestList = _interopRequireDefault(require("./AutoSuggestList"));
var _Button = _interopRequireDefault(require("../v1/components/Button/Button"));
var _omit = _interopRequireDefault(require("lodash/omit"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * Calculates the difference between current scroll position and position of element, if outside visible window
 *
 * @param {object} elementAttributes
 * @param {number} elementAttributes.parentScrollTop Value of parent element `scrollTop` attribute
 * @param {number} elementAttributes.parentHeight Value of parent element `clientHeight` attribute
 * @param {number} elementAttributes.elementOffsetTop Value of element `offsetTop` attribute
 * @param {number} elementAttributes.elementHeight Value of element `clientHeight` attribute
 *
 * @returns {number} Pixel value of how far to scroll to view element
 */
const getScrollDifferential = ({
  parentScrollTop,
  parentHeight,
  elementOffsetTop,
  elementHeight
}) => {
  if (elementOffsetTop < parentScrollTop) {
    return elementOffsetTop - parentScrollTop;
  }
  const parentLowerBound = parentScrollTop + parentHeight;
  const elementLowerBound = elementOffsetTop + elementHeight;
  if (elementLowerBound > parentLowerBound) {
    return elementLowerBound - parentLowerBound;
  }
  return 0;
};
const CUSTOM = 'custom';
class AutoSuggestInput extends _react.Component {
  static defaultProps = {
    iconPosition: 'left',
    name: 'search',
    placeholder: 'Search',
    suggestions: [],
    searchType: ''
  };
  constructor(props) {
    super(props);
    const {
      defaultValue
    } = props;
    this.state = {
      suggestionsHidden: true,
      ignoreBlur: false,
      value: defaultValue || '',
      activeSuggestion: null,
      inputKey: (0, _v.default)()
    };
  }
  componentDidMount() {
    const {
      suggestions
    } = this.props;
    this._input?.node?.addEventListener('invalid', this._onInvalid);

    /**
     * Blur is manually controlled here because of a glitch when user clicks on the url bar
     */
    window.addEventListener('click', this._onInputBlur);
    if (suggestions.length) {
      this._showSuggests();
    } else {
      this._hideSuggests();
    }
  }
  componentDidUpdate(prevProps, prevState) {
    const {
      suggestions,
      autoActivateFirstSuggest
    } = this.props;
    const {
      value
    } = this.state;
    const {
      suggestions: prevSuggestions
    } = prevProps;
    if (prevState.value !== value) {
      if (!value) {
        this._input?.node?.focus();
      }
    }

    // This avoids unnecessary rerenders
    const prevSuggestionsToCompare = prevSuggestions?.map(pre => (0, _omit.default)(pre, 'componentToRender')) || [];
    const suggestionsToCompare = suggestions?.map(cus => (0, _omit.default)(cus, 'componentToRender')) || [];
    const {
      activeSuggestion
    } = this.state;
    if (!(0, _isEqual.default)(prevSuggestionsToCompare, suggestionsToCompare)) {
      if (suggestions && suggestions?.length) {
        this._showSuggests();
        if (autoActivateFirstSuggest && activeSuggestion?.id !== suggestions?.[0]?.id) {
          this._activateSuggest({
            direction: 'next'
          });
        }
      } else {
        this._hideSuggests();
      }
    }
  }
  componentWillUnmount() {
    this._input?.node?.removeEventListener('invalid', this._onInvalid);
    window.removeEventListener('click', this._onInputBlur);
  }
  _onInvalid = evt => {
    evt.preventDefault();
    const {
      onInvalid
    } = this.props;
    if (onInvalid) {
      onInvalid(evt.currentTarget.validity);
    }
  };
  _onInputChange = evt => {
    this.setState({
      value: evt.target.value
    });
    const {
      onChange
    } = this.props;
    if (onChange) {
      onChange(evt);
    }
  };
  _onInputKeyDown = evt => {
    switch (evt.which) {
      case 40:
        this._nextSuggest(evt);
        break;
      case 38:
        this._previousSuggest(evt);
        break;
      case 13:
        this._selectSuggest(evt);
        break;
      case 27:
        this._hideSuggests(evt);
        break;
    }
  };
  _onInputFocus = () => {
    const {
      onFocus
    } = this.props;
    if (onFocus) {
      onFocus();
    }
    this.setState({
      suggestionsHidden: false
    });
  };
  _onInputBlur = event => {
    /**
     * The input is not blurred when user clicks on the search input in hourly, monthly and airport
     * The input is not blurred when users clicks outside the page. ex - url bar or refresh button
     * The input is not blurred when user clicks on the Airport tab (i.e. tabs-3--tab-2)
     */
    if (!this.state.ignoreBlur && event?.target?.name !== 'search-input' && event?.target?.name !== 'search' && event?.target?.id !== 'tabs-3--tab-2') {
      this._hideSuggests();
    }
  };
  _onSuggestionMouseDown = () => {
    this.setState({
      ignoreBlur: true
    });
  };
  _onSuggestionMouseOut = () => {
    this.setState({
      ignoreBlur: false
    });
  };
  _onSelectSuggestion = ({
    suggestion = false
  }) => {
    const {
      onSuggestionSelect
    } = this.props;
    let selectedSuggestion = suggestion;
    if (!selectedSuggestion) {
      selectedSuggestion = {};
      selectedSuggestion.label = this.state.value;
    }
    this.setState({
      suggestionsHidden: true,
      value: selectedSuggestion.label,
      inputKey: (0, _v.default)()
    });
    onSuggestionSelect?.(selectedSuggestion);
  };
  _onClear = () => {
    const {
      onClear
    } = this.props;
    this.setState({
      value: '',
      inputKey: (0, _v.default)()
    });
    if (onClear) {
      onClear();
    }
  };
  _nextSuggest() {
    this._activateSuggest({
      direction: 'next',
      isArrowPress: true
    });
  }
  _previousSuggest() {
    this._activateSuggest({
      direction: 'prev',
      isArrowPress: true
    });
  }
  _selectSuggest = evt => {
    evt.preventDefault();
    this._onSelectSuggestion({
      suggestion: this.state.activeSuggestion
    });
  };
  _showSuggests() {
    if (this.state.suggestionsHidden) {
      this.setState({
        suggestionsHidden: false
      });
    }
  }
  _hideSuggests() {
    const {
      onBlur
    } = this.props;
    if (onBlur) {
      onBlur();
    }
    if (!this.state.suggestionsHidden) {
      this.setState({
        suggestionsHidden: true
      });
    }
  }
  _activateSuggest({
    direction,
    isArrowPress = false
  }) {
    const {
      suggestions
    } = this.props;
    const {
      activeSuggestion
    } = this.state;
    const suggestionsCount = suggestions.length - 1;
    const next = direction === 'next';
    const newState = {};
    let newActiveSuggestion = null;
    let newIndex = 0;
    let i = 0;
    for (i; i <= suggestionsCount; i++) {
      if (suggestions[i] === activeSuggestion) {
        newIndex = next ? i + 1 : i - 1;
      }
    }
    if (!activeSuggestion) {
      newIndex = next ? 0 : suggestionsCount;
    }
    if (newIndex < 0) {
      newIndex = suggestionsCount;
    } else if (newIndex > suggestionsCount) {
      newIndex = 0;
    }
    if (newIndex >= 0 && newIndex <= suggestionsCount) {
      newActiveSuggestion = suggestions[newIndex];
    }
    newState.activeSuggestion = newActiveSuggestion;
    if (isArrowPress) {
      newState.value = newActiveSuggestion ? newActiveSuggestion.label : '';
    }
    if (this._list) {
      const activeChild = this._list.querySelector('.AutoSuggestInput-item-active');
      let nextActiveChild = next ? activeChild?.nextSibling : activeChild?.previousSibling;
      nextActiveChild = nextActiveChild ? nextActiveChild : next ? this._list.firstElementChild : this._list.lastElementChild;
      if (nextActiveChild) {
        const scrollDiff = getScrollDifferential({
          parentScrollTop: this._list.scrollTop,
          parentHeight: this._list.clientHeight,
          elementOffsetTop: nextActiveChild.offsetTop,
          elementHeight: nextActiveChild.clientHeight
        });
        if (scrollDiff) {
          this._list.scrollTo(nextActiveChild.offsetLeft, this._list.scrollTop + scrollDiff);
        }
      }
    }
    this.setState(newState);
  }

  /**
   * Getter for the input DOM element.
   *
   * @public
   * @returns {Element} - The input element.
   */
  get node() {
    return this._input?.node;
  }
  render() {
    const {
      className,
      suggestions,
      suggestionBoxFooter,
      additionalInputProps,
      searchSuggestionsTitle,
      additionalSuggestionsTitle,
      additionalSuggestions,
      searchType,
      ...textInputProps
    } = this.props;
    const {
      value,
      inputKey,
      activeSuggestion,
      suggestionsHidden
    } = this.state;
    const isCustomSuggestions = searchType === CUSTOM;
    const classes = (0, _classnames.default)('AutoSuggestInput', {
      'AutoSuggestInput-suggestions-active': !suggestionsHidden
    }, {
      'AutoSuggestInput-no-suggestions': !suggestions || !suggestions.length
    }, className);
    const newAdditionalInputProps = {
      ...additionalInputProps,
      onKeyDown: this._onInputKeyDown,
      autoComplete: 'off'
    };
    return /*#__PURE__*/_react.default.createElement("div", {
      ref: node => {
        this._container = node;
      },
      className: classes
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "FormElement-control"
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, (0, _extends2.default)({
      key: inputKey,
      ref: node => {
        this._input = node;
      }
    }, textInputProps, {
      additionalInputProps: newAdditionalInputProps,
      defaultValue: value,
      onChange: this._onInputChange,
      onFocus: this._onInputFocus
    })), /*#__PURE__*/_react.default.createElement(_AutoSuggestList.default, {
      ref: node => {
        this._list = node;
      },
      hidden: suggestionsHidden,
      suggestions: suggestions || [],
      activeSuggestion: activeSuggestion,
      suggestionBoxFooter: suggestionBoxFooter,
      onSuggestionSelect: this._onSelectSuggestion,
      onSuggestionMouseDown: this._onSuggestionMouseDown,
      onSuggestionMouseOut: this._onSuggestionMouseOut,
      additionalSuggestionsTitle: additionalSuggestionsTitle,
      additionalSuggestions: additionalSuggestions,
      searchSuggestionsTitle: searchSuggestionsTitle,
      isCustomSuggestions: isCustomSuggestions
    }), value && /*#__PURE__*/_react.default.createElement(_Button.default, {
      className: "AutoSuggestInput-clear",
      onClick: this._onClear
    }, /*#__PURE__*/_react.default.createElement(_xCircle.default, null))));
  }
}
exports.default = AutoSuggestInput;